<mat-drawer-container class="mat-typography">

  <mat-drawer #drawer mode="over" position="end" class="drawer">
    <mat-drawer-content>
      <div class="top-panel flex-row">
        <h2 class="font1 bold">{{ ctx?.operation == ActionOperation.Add ? 'Add next step' : 'Edit current step' }}</h2>
        <div class="text-right">
          <lib-button variant="icon" icon="close" (buttonClick)="drawer.toggle()">Close</lib-button>
        </div>
      </div>
      <div>
        <mat-form-field class="full-width">
          <mat-label>Strategy</mat-label>
          <mat-select placeholder="" (selectionChange)="onStrategyChanged($event.value)" [ngModel]="strategy?.name">
            @for (strategyName of strategyNames; track strategyName) {
              <mat-option [value]="strategyName">{{ strategyName }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <app-strategy-edit [strategy]="strategy"></app-strategy-edit>

        @if (errors?.length > 0) {
          <div class="errors">
            @for (err of errors; track err) {
              <div class="error">{{ err }}</div>
            }
          </div>
        }

        <div class="flex-row gap-8">
          <lib-button variant="raised" (buttonClick)="onSave()">Save step</lib-button>
          <lib-button variant="stroked" (buttonClick)="onCancel()">Cancel</lib-button>
          <div></div>
        </div>
      </div>
    </mat-drawer-content>
  </mat-drawer>
</mat-drawer-container>

